import { useSelector } from "react-redux";
import { RootState } from "../store";

/**
 * Get current languages selection
 * @returns 
 */
export const useSelectedLanguages = ():Array<string> => {
  return useSelector((state: RootState) => state.app.selectedLanguages);
}